
import { Component, Vue } from "vue-property-decorator";
import paikeItem from "./components/paike-item/index.vue";
import { Icon, List, PullRefresh } from "vant";
import request from "@/api";
import {
  commonJumpNewsDetail,
  setWechatShare
} from "@/views/kaizhou-shuai-video/hooks";

@Component({
  name: "paike",
  methods: { commonJumpNewsDetail },
  components: {
    "paike-item": paikeItem,
    "van-list": List,
    "van-pull-refresh": PullRefresh,
    "van-icon": Icon
  }
})
export default class paike extends Vue {
  loading = false;
  finished = false;
  list = [];
  columnId = "";
  async created() {
    const ids = this.$route.query.ids as string;
    this.columnId = await this.getColumId(ids);
    setWechatShare();
  }

  activated() {
    setWechatShare();
  }

  async mounted() {
    this.handleShowHeader();
  }

  async getColumId(ids: string): Promise<string> {
    const temp = await request.seatNews(ids);
    return JSON.parse(temp.data[0].target.ext).openData.columnId;
  }

  async onLoad() {
    const lastEl: any = this.list.slice(-1)[0];
    const lastId = lastEl?.id;
    const res = await request.shortVideo(lastId);
    const data = res.data.dataList;
    this.loading = false;
    this.list = this.list.concat(data);
    if (data.length < 10) {
      this.finished = true;
    }
  }
  isLoading = false;
  async onRefresh() {
    const res = await request.shortVideo();
    this.list = res.data.dataList;
    this.isLoading = false;
  }

  isShowHeader = true;
  handleShowHeader() {
    if (window.history.length <= 1) {
      this.isShowHeader = false;
    }
  }
}
